// Header.jsx
import React, { useState } from 'react';
import Navbar from './Navbar';
import Brochure from './Brochure';
import EnessaLogo from '../assets/logo/Enessa-Logo-2.png';
import { Link } from 'react-router-dom';

const Header = () => {
  const { downloadBrochure, BrochureModal } = Brochure();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
    <header className="relative z-10 p-4 bg-white lg:px-8 lg:bg-transparent">
      <div className="flex items-center gap-4">

        {/* LEFT: Logo - never shrinks */}
        <div className="flex-shrink-0">
          <Link to="/" className="block">
            <img src={EnessaLogo} alt="logo" className="h-20 lg:h-26" />
          </Link>
        </div>

        {/* CENTER: Navbar - will take remaining space */}
        <Navbar />

        {/* RIGHT: Buttons - allow buttons to shrink on narrower large screens */}
        <div className="items-center flex-shrink-0 hidden min-w-0 gap-2 lg:flex xl:gap-4">
          {/* Download Brochure button - shrink and responsive sizes */}
          <button
            onClick={downloadBrochure}
            className="
              px-3 py-2 md:px-4 md:py-2 lg:px-4 lg:py-2 xl:px-6 xl:py-3
              text-[12px] md:text-sm lg:text-sm xl:text-base
              font-medium transition-all border-2 rounded-full border-slate-700 text-slate-700
              hover:bg-slate-700 hover:text-white
              whitespace-nowrap
              shrink
              min-w-0
            "
          >
            {/* if label becomes too long it will keep on one line but padding will reduce */}
            Download Brochure
          </button>

          {/* Enquiry Form button */}
          <Link
            to="/contact#inquiry-section"
            className="
              px-3 py-2 md:px-4 md:py-2 lg:px-4 lg:py-2 xl:px-6 xl:py-3
              text-[12px] md:text-sm lg:text-sm xl:text-base
              font-medium text-white transition-all
              bg-red-500 rounded-full hover:bg-red-600
              whitespace-nowrap
              shrink
              min-w-0
            "
          >
            Enquiry Form
          </Link>
        </div>

        {/* MOBILE: hamburger toggle */}
        <button
          className="p-2 ml-auto lg:hidden"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="toggle mobile menu"
        >
          {mobileMenuOpen ? (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile menu (unchanged) */}
      {mobileMenuOpen && (
        <div className="p-4 mt-4 bg-white rounded-lg shadow-lg lg:hidden">
          <nav className="space-y-3">
            <Link to="/" onClick={() => setMobileMenuOpen(false)} className="block font-medium text-slate-800">Home</Link>
            <Link to="/services" onClick={() => setMobileMenuOpen(false)} className="block font-medium text-slate-800">Services</Link>
            <Link to="/products" onClick={() => setMobileMenuOpen(false)} className="block font-medium text-slate-800">Products</Link>
            <Link to="/innovation" onClick={() => setMobileMenuOpen(false)} className="block font-medium text-slate-800">Innovation</Link>
            <Link to="/blogs" onClick={() => setMobileMenuOpen(false)} className="block font-medium text-slate-800">Blogs</Link>
            <Link to="/about" onClick={() => setMobileMenuOpen(false)} className="block font-medium text-slate-800">About Us</Link>
            <Link to="/contact" onClick={() => setMobileMenuOpen(false)} className="block font-medium text-slate-800">Contact Us</Link>
          </nav>

          <div className="mt-4 space-y-2">
            <button onClick={() => { downloadBrochure(); setMobileMenuOpen(false); }} className="w-full px-4 py-2 font-medium border-2 rounded-full border-slate-700 text-slate-700">Download Brochure</button>
            <Link to="/contact" onClick={() => setMobileMenuOpen(false)} className="block w-full px-4 py-2 font-medium text-center text-white bg-red-500 rounded-full">Enquiry Form</Link>
          </div>
        </div>
      )}
    </header>
    {BrochureModal && <BrochureModal />}
    </>
  );
};

export default Header;
